module.exports = __webpack_public_path__ + "static/media/290627.93ff14e6.png";